// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WrapperPage_wrapper__PJSkr","notion":"WrapperPage_notion__G6apY"};